// extracted by mini-css-extract-plugin
export default {"table":"Users_table__GJ1Dw","row":"Users_row__yR91g"};